// IMPORTANT!
// The following import is required to make FullCalendar work with Vite.
// It triggers side effects that are required for FullCalendar's initialisation.
// These side effects MUST occur before any FullCalendar plugins are imported.
// Vite's HMR does not guarantee the loading order of modules,
// so we add this import at the top of our app's entry point.
import '@fullcalendar/react/dist/vdom';

import './utils/sentryInit';

import { installClientIdFetchInterceptor } from '@payaca/shared-isomorphic/clientId/installFetchInterceptor';
import { initPlausible } from '@payaca/shared-web/analytics/plausible';
import '@payaca/utilities/polyfills';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// Stylesheets
import '@payaca/styles';
import './styles.css';

import App from './App';
import { store } from './api';
import * as api from './services/api';
import { BUILD_VERSION } from './utils/buildVersion';

import './i18n';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

installClientIdFetchInterceptor({
  clientId: 'webapp-provider',
  clientVersion: BUILD_VERSION,
  apiHost: import.meta.env.VITE_API_HOST,
});

initPlausible({ domain: import.meta.env.VITE_PLAUSIBLE_DOMAIN });

api.setStore(store);

if (import.meta.env.VITE_APP_ENV === 'production') {
  console.log = () => null;
}

const root = createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleOAuthProvider>
);

// N.B. There are no export barrels for these packages.
// You should import from the specific file you require.
// Here we specify 'index' explicitly as it's the only file
// in the packages' example content.
